module.exports = __webpack_public_path__ + "img/industry.54a09d84.svg";